// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"486edb41","171":"008e2cca","400":"a21ac7d7","456":"723d116a","466":"3e3228c0","507":"2b96e5da","576":"540bda25","759":"08aa9149","780":"30272cbc","887":"e3f59708","968":"023bf882"}[chunkId] + ".chunk.js";
};